import React, { Component, PropTypes } from 'react';
import { Input } from 'react-bootstrap';

export default class CustomInput extends Component {
  static propTypes = {
    errors: PropTypes.array,
    name: PropTypes.string,
    refInput: PropTypes.string,
  };

  static defaultProps = {
    errors: [],
    name: '',
  };

  getValue = () => {
    const { refInput } = this.props;

    return this.refs[refInput].getValue();
  };

  render() {
    const { errors, name, refInput, ...props } = this.props;

    const isError = !!errors.filter(error => error.path === name).length;

    const firstError = errors.find(error => error.path === name);

    return (
      <div className={isError ? 'has-error' : undefined}>
        <Input
          {...props}
          bsStyle={isError ? 'error' : undefined}
          id={`input_${name}`}
          ref={refInput}
        />

        {firstError && (
          <p className="help-block" style={{ marginTop: -10 }}>
            {firstError.message}
          </p>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/inputs/Input.js